<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/kerstmis/Asset 48.png" alt="">
    <img draggable="false" class="clickable" id="tree_1" @click="goToGame(63)" src="./../../assets/images/kerstmis/Asset 63.png" alt="">
    <img draggable="false" class="clickable" id="tree_2" @click="goToGame(64)" src="./../../assets/images/kerstmis/Asset 64.png" alt="">
    <img draggable="false" class="clickable" id="tree_3" @click="goToGame(65)" src="./../../assets/images/kerstmis/Asset 65.png" alt="">

    <span id="kerstmis_title_text_2">Kies een kerstboom om mee te starten</span>
  </span>
</template>

<script>
export default {
  name: "KerstmisMenu2",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToStart() {
      this.$router.push('/kerstmis/start');
    },
    goToGame(tree_no) {
      this.$store.dispatch('kerstmis/asyncUpdateSelectedTree', {
          selected_tree: tree_no,
      });

      this.$router.push('/kerstmis/game');
    },
  },

  computed: {}
};
</script>

<style>
  #kerst_play_btn {
    position: absolute;
    margin-top: 32%;
    left: 40%;
    width: 20%;
  }
  #kerstmis_title_text_2 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 4%;
    width: 65%;
    left: 17.5%;
    color: #1b7537;
    font-size: 3.5vw;
    text-align: center;
    z-index: 1;
  }
  #kerstmis_description_text_1 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 14%;
    width: 80%;
    left: 10%;
    color: #1b7537;
    font-size: 2.5vw;
    text-align: center;
    z-index: 1;
  }
  #kerstmis_description_text_2 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 20%;
    width: 80%;
    left: 10%;
    color: #1b7537;
    font-size: 2.5vw;
    text-align: center;
    z-index: 1;
  }
  #kerstmis_description_text_3 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 26%;
    width: 80%;
    left: 10%;
    color: #1b7537;
    font-size: 2.5vw;
    text-align: center;
    z-index: 1;
  }

  #tree_1 {
    position: absolute;
    margin-top: 15%;
    width: 28%;
    left: 4%;
  }
  #tree_2 {
    position: absolute;
    margin-top: 15%;
    width: 28%;
    left: 35%;
  }
  #tree_3 {
    position: absolute;
    margin-top: 15%;
    width: 28%;
    left: 68%;
  }
</style>


